<template>
  <modal
    id="delete-modal"
    :size="'lg'"
    :confirm-text="'Delete Account'"
    :confirm-class="`btn btn-danger`"
    @confirm="deleteAccount"
    :close-text="'Back'"
    close-class="btn-default pull-left"
    @closed="showUpdatedTermModal"
    :isLoading="loading"
    :showExit="false"
    :optionalFirstText="optionalFirstText"
    :optionalSecondText="optionalSecondText"
    :confirmDisabled="!checked"
  >
    <template v-slot:title>
      Updated Terms of Use
    </template>
    <template v-slot:body>
      <div>
        Not accepting the updated terms of use will result in the deletion of your account. This
        cannot be undone.
        <strong>Are you sure that you would like to delete your account?</strong>
      </div>

      <div class="mt-20">
        <input type="checkbox" id="check-delete-account" v-model="checked" />
        <label for="check-delete-account" class="label-bold-off">Yes, delete my account</label>
      </div>
    </template>
  </modal>
</template>

<script>
  import { mapActions } from 'vuex';
  export default {
    data() {
      return {
        checked: false,
        loading: false,
        loaderStyle: {
          position: 'relative',
          height: '200px',
        },
        optionalFirstText:
          'Your account has been deleted. If this was done in error, please contact our team at authoring@capsim.com.',
        optionalSecondText: 'You will be redirected momentarily.',
      };
    },
    methods: {
      ...mapActions('user', ['deleteAccount']),
      showUpdatedTermModal() {
        this.$emit('showUpdatedTermModal');
        $('#delete-modal').modal('hide');
      },
      async deleteAccount() {
        this.loading = true;
        await this.deleteAccount();
        // 5 seconds delay per PDD's request
        setTimeout(() => {
          window.location.href = 'https://capsim.com';
        }, 5000);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .label-bold-off {
    font-weight: normal;
  }
</style>
